/*global window, jQuery, document, localStorage, theme*/
var url = window.location.href;

jQuery(document).ready(function ($) {
    'use strict';

    var partnerId = "";
    url = window.location.href;

  var ipCountry = localStorage.getItem('ipCountry');
  var ipCity = localStorage.getItem('ipCity');
   if(url.indexOf('?country=ca') >= 0) {
        localStorage.setItem('ipCountry', 'ca');
        $('body').addClass('geo-ready ca');
        ipCountry = 'ca';
        
     
      }
  if(url.indexOf('?country=us') >= 0) {
        localStorage.setItem('ipCountry', 'us');
        $('body').removeClass('ca');
        ipCountry = 'us';
        
      }

    if (ipCountry === null || ipCountry.length === 0) {
     
         localStorage.setItem('ipCountry', 'us');
        $('body').addClass('geo-ready us');
        
        $.get("https://ipinfo.io?token=3dd18231f6dd5d", function (response) {
          console.log('ipinfo response', response);
           ipCountry = response.country.toLowerCase();
           ipCity = response.city.toLowerCase();
         localStorage.setItem('ipCity', ipCity);

            localStorage.setItem('ipCountry', ipCountry);
            localStorage.setItem('ipCity', ipCity);
            $('body').removeClass('geo-ready');
            $('body').removeClass('us');
            $('body').addClass('geo-ready ' + ipCountry + ' ' + ipCity);
        }, "jsonp")
        .fail(function() {
    		
            localStorage.setItem('ipCountry', 'us');
            $('body').addClass('geo-ready us');
		});

  
    } else {
            $('body').addClass('geo-ready ' + ipCountry + ' ' + ipCity);

        if (ipCountry === 'ca') {
              SetCartCount();
          	  localStorage.removeItem('dealerName');
          	localStorage.removeItem('cartUrl');
            if (rootPath.indexOf('pages/pro') >= 0) {
                
         		jQuery('.main-content').first().html('Unfortunately the Yakima Pro program is only available to applicants in the United States. ');
            } else if (rootPath.indexOf('products/') >= 0) {
                // Hide out of stock message, out of stock button & back in stock button
                $('.product-single__meta .out-of-stock-message, .product-single__meta .btn--out-of-stock, .product-single__meta #BIS_trigger').remove();

              
              $('a.site-header__cart').click(function(e) {
                        e.preventDefault();
                 window.location = '/pages/shopping-cart';
                
              });
                ShowCartButton();
            } else if (rootPath.indexOf('/cart') >= 0) {
                $addToCartButton.hide();

                $('.cart__submit-controls').first()
                    .append('<a class="btn rightpad" onclick="caCheckout(\'https://rackattack.com/yakimacart\')" href="#">Checkout at RackAttack</a>');
                $('.cart__submit-controls').first()
                    .append('<a class="btn" id="rfcCheckout"  onclick="caCheckout(\'http://www.racksforcars.com/store/go/quickadd/?\')" href="#">Checkout at RacksForCars</a>');
            }
          if(window.location.href.indexOf('timberline-towers-4-pack') > 0 && window.location.href.indexOf('timberline-towers-4-pack-legacy') <= 0) {
            window.location.href = 'timberline-towers-4-pack-legacy';
          }
          if(window.location.href.indexOf('timberline-towers-2-pack') > 0 && window.location.href.indexOf('timberline-towers-2-pack-legacy') <= 0) {
            window.location.href = 'timberline-towers-2-pack-legacy';
          }
        }
    }
    if ((url.indexOf('retailer-fmc') >= 0) && url.indexOf('partnerId=') >= 0) {


        partnerId = url.substring(url.indexOf('partnerId=') + 10);
        if(partnerId.indexOf('#') >= 0)
            partnerId = partnerId.substring(0, partnerId.indexOf('#'));
        if(partnerId.indexOf('&') >= 0)
            partnerId = partnerId.substring(0, partnerId.indexOf('&'));
      
        localStorage.setItem('partnerId', partnerId);

        jQuery('#vehicle-fmc-close a').unbind().bind("click tap", function (e) {
            if (url.indexOf('/ca/') >= 0)
                window.location.href = '/ca';
            else
                window.location.href = '/';

            e.preventDefault();
        });

        setCookie('discount_code', '', 1);
        localStorage.removeItem('couponCode');

       fmcModalInit();
    }
    else if ('partnerId' in localStorage && localStorage.getItem('partnerId') !== 'null') {
		var lastPageLoad = localStorage.getItem('lastPageLoad');
        partnerId = localStorage.getItem('partnerId');
        if(lastPageLoad != null && lastPageLoad.length > 0) {
          var d = new Date(lastPageLoad);
          var diff = new Date() - d;
          if(diff > 3600000) {
            localStorage.setItem('partnerId', '');
            localStorage.setItem('dealerName', '');
            partnerId = '';
          }
        }
      if(partnerId.length > 0)
      {
        jQuery('#get_started_button').unbind().bind("click tap", function (e) {
            fmcModalInit(false);
            gotoPage('intro', true);
            jQuery('#fmc-add-vehicle').hide();
            if (jQuery('body.catalog-product-view').length > 0)
                localStorage.setItem('referralType', 'Product');
            else if (jQuery('body.catalog-category-view').length > 0)
                localStorage.setItem('referralType', 'Category');
            else
                localStorage.setItem('referralType', '');
            e.preventDefault();
        });
      }
    }
    if (partnerId.length > 0 && partnerId !== 'null') {

        $('body').addClass('whitelabel');
        // Hide out of stock message, out of stock button, back in stock button & locally
        $('.product-single__meta .out-of-stock-message, .product-single__meta .btn--out-of-stock, .product-single__meta #BIS_trigger, .product-single__meta .oos-locally').remove();
      
        $('a.site-header__cart').click(function(e) {
               e.preventDefault();
                 window.location = '/pages/shopping-cart';
                
        });

      $('.single-option-selector-product-template').change(function() {
        ShowCartButton();
      });
        SetCartCount();
        //jQuery('.site-header__logo-image img').attr('src', '/assets/YakimaPro.png');
        //window.location(url.substring(0, url.indexOf('/whitelabel')));

        configureDealer(partnerId);

        $('form.product-form').attr('action', null);

        if ($('.product-view.tower-system').length === 0) {
            $('.product-form__cart-submit')
                .find('span')
                    .text(theme.strings.addToCart)
                    .end()
                .removeAttr('aria-disabled')
                .attr('aria-label', theme.strings.addToCart)
                .off()
                .click(function (e) {
                    e.preventDefault();

                    var sku = $('.product-single__meta .variant-sku').first().text();
                    var name = $('.product-single__meta .product-single__title').first().text();
                    var price = $('.product-single__meta .product__price-canada .price-item--regular').first().text().replace('$', '').replace(',', '');
                    var cart = '';

                    if(localStorage.getItem('partnerId') == 41)
                      sku = $('#variant-upc').text();
                    if (localStorage.getItem('cart-transfer')) {
                        cart = localStorage.getItem('cart-transfer');
                    }

                    localStorage.setItem('cart-transfer', cart + '|' + sku + ',1,' + price + ',' + name);
					SetCartCount();

                    $(e.currentTarget)
                        .css('background-color', '#666')
                    	.unbind()
                        .find('span')
                            .text('Added');
                });
        }

        if (url.indexOf('pages/pro') >= 0) {
            window.location = '/';
        }

        jQuery('#dealer_cart_link').unbind().bind("click tap", function (event) {
            event.preventDefault();
            partnerCheckout(jQuery('#dealer_cart_link').attr('href') );
            return false;
        });

        jQuery('.cart__submit-control').unbind().bind("click tap", function (event) {
            event.preventDefault();
            partnerCheckout(jQuery('#dealer_cart_link').attr('href') );

            return false;
        });
      
    }
  
    if (window.location.href.indexOf('/shopping-cart') >= 0) {
        cartPage();
    }
  
      localStorage.setItem('lastPageLoad', new Date().toLocaleString());
  
    if(url.indexOf('&redirect=') >= 0) {
          var redirect = url.substring(url.indexOf('&redirect=') + 10);
          if(redirect.length > 1) {
          url = 'https://www.yakima.com' + url.substring(url.indexOf('&redirect=') + 10);
          window.location = url;
          }
    }
});

function ShowCartButton() {
        var $addToCartButton = $('.product-form__cart-submit');
 // Display add to cart button
  $addToCartButton
  .find('span')
  .text(theme.strings.addToCart)
  .end()
  .removeAttr('aria-disabled')
  .attr('aria-label', theme.strings.addToCart)
  .off()
  .click(function (e) {
    e.preventDefault();

    var sku = $('.product-single__meta .variant-sku').first().text();
    var name = $('.product-single__meta .product-single__title').first().text();
    var price = $('.product-single__meta .product__price-canada .price-item--regular').first().text().replace('$', '').replace(',', '');

    if(localStorage.getItem('partnerId') == 41)
      sku = $('#variant-upc').text();
    var cart = '';

    if (localStorage.getItem('cart-transfer')) {
      cart = localStorage.getItem('cart-transfer');
    }

    localStorage.setItem('cart-transfer', cart + '|' + sku + ',1,' + price + ',' + name);
    SetCartCount();
    $(e.currentTarget)
    .css('background-color', '#666')
    .find('span')
    .off()
    .unbind()
    .text('Added');
  }); 
}

function SetCartCount() {
  
  var transfer = localStorage.getItem('cart-transfer');
  var itemCnt = 0;
  if(transfer != null && transfer != '') {
    var cartItems = transfer.split('|');
    itemCnt = cartItems.length - 1;
  }
  if(itemCnt == 0)
    $('#CartCount').addClass('hide');
  else
    $('#CartCount').removeClass('hide').find('span').first().text(itemCnt);
}
function partnerCheckout(url) {
  var i = 1;

  var transfer = localStorage.getItem('cart-transfer');
  var cartItems = transfer.split('|');
  	for (i = 0; i < cartItems.length; ++i) {
    	var cols = cartItems[i].split(',');
      if(cols[0].length > 0) {
        if(url.indexOf('?') < 0) url += '?'; else url += '&';
        var pname = cols[3];
        if(pname.indexOf('(') >= 0) pname = pname.substring(0, pname.indexOf('('));
    	url += 'p' + i + '=' + cols[0] + ',' + cols[1] + ',' + cols[2] + ',' + pname;
      }
	}
  
  window.location.href = url;
  localStorage.removeItem('cart-transfer');
  localStorage.removeItem('partnerId');
}


function configureDealer(partnerId) {
    var dealerName = "";
    var imgUrl = "";
    var cartUrl = "";
    switch (partnerId) {
        case "3":
            dealerName = "Rack Attack";
            imgUrl = "https://www.rackattack.com/img/layout/ra-logo.png";
            cartUrl = "https://rackattack.com/yakimacart";
            break;
        case "5":
            dealerName = "BackCountry";
            imgUrl = "http://d2amiavn18tu8z.cloudfront.net/images/backcountry.png";
            cartUrl = "http://www.backcountry.com/Store/catalog/vendorPackageLanding.jsp?CMP_ID=PM_VL0291&";
            break;
        case "7":
            dealerName = "ORS Racks Direct";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/dealer_ors_racks_direct.png";
            cartUrl = "http://fitguides.orsracksdirect.com/order/yakima/";
            break;
        case "9":
            dealerName = "REI";
            imgUrl = "//satchel.rei.com/media/img/header/rei-co-op-logo-black.svg";
            cartUrl = "http://www.rei.com/YakimaRackFitterPurchase?storeId=8000&cm_mmc=vl_yakima-_-datafeed_m-_-BuyNow-_-p2p&";
            break;
        case "10":
            dealerName = "Campmor";
            imgUrl = "//cdn.shopify.com/s/files/1/0301/4023/5913/files/campmor_logo_record_250x.png";
            cartUrl = "http://www.campmor.com/outdoor/gear/YakCfgInReqView?storeId=226&langId=-1&";
            break;
        case "12":
            dealerName = "Rack N Road";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/dealer_rack_n_road.png";
            cartUrl = "http://www.racknroad.com/cart-yakima-transfer.php";
            break;
        case "13":
            dealerName = "Rack Warehouse";
        imgUrl = "https://www.racknroad.com/img_store/racknroad-vehicle-outfitters-since-1991-v3.jpg";
            cartUrl = "https://rackwarehouse.com/fitguides/FitGuideCart.aspx";
            break;
        case "14":
            dealerName = "Cartop";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/dealer_cartop.png";
            cartUrl = "http://www.paddlers.com/cartop/cart_yakima.asp";
            break;
        case "15":
            dealerName = "Total Racks";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/totalracks.png";
            cartUrl = "http://www.totalracks.com/v/vspfiles/files/yakima.asp";
            break;
        case "17":
            dealerName = "Rock Creek Outfitters";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/dealer_rockcreek.png";
            cartUrl = "http://www.rockcreek.com/global/gadgets/yakimaCart.jsp";
            break;
        case "18":
            dealerName = "Rack Solid";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/dealer_rack_solid.png";
            cartUrl = "http://www.racksolid.com/index.php?main_page=yakima_products";
            break;
        case "19":
            dealerName = "TravelCountry.com";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/TravelCountry_logo-yakima_configurator.png";
            cartUrl = "http://www.travelcountry.com/shop/Action/Extra_YakimaIn?RefId=121&RefType=Vendor";
            break;
        case "21":
            dealerName = "RacksForCars";
            imgUrl = "https://cdn.powered-by-nitrosell.com/store_images/13/3226/RacksForCars3.png";
            cartUrl = "http://www.racksforcars.com/store/go/quickadd/";
            break;
        case "22":
            dealerName = "CARID";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/CARiD-logo.jpg";
            cartUrl = "http://www.carid.com/configure_tech.php";
            break;
        case "25":
            dealerName = "NRS";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/social_400x400.jpg";
            cartUrl = "http://www.nrs.com/shop/yakima_basket.asp";
            break;
        case "26":
            dealerName = "cracksandracks.com";
            imgUrl = "https://www.cracksandracks.com/skin/frontend/ultimo/devcrack/images/Website-Logo-2016.jpg";
            cartUrl = "https://www.cracksandracks.com/import-yakima.php";
            break;
        case "27":
            dealerName = "MooseJaw";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/dealer_moosejaw.png";
            cartUrl = "http://www.moosejaw.com/moosejaw/shop/MJYakimaRequestProcessor?storeId=10208&catalogId=10000001&cm_mmc=P2P-_-Yakima-_-na-_-BuyNow&ad_id=Yakima&";
            break;
        case "28":
            dealerName = "ReRack";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/rerack-logo-186x121.png";
            cartUrl = "https://www.rerack.com/cart.php?action=add";
            break;
        case "29":
            dealerName = "EBikes Florida";
            imgUrl = "https://www.yakima.com/media/wysiwyg/dealerlogo/eBikes-florida-logo.png";
            cartUrl = "http://www.ebikesflorida.com/cart/";
            break;
        case "30":
            dealerName = "West Marine";
            imgUrl = "http://d2amiavn18tu8z.cloudfront.net/images/west-marine.jpg";
            cartUrl = "http://www.westmarine.com/cart/add_yakima_product";
            break;
        case "32":
            dealerName = "Austin Kayak";
            imgUrl = "https://www.yakima.com/media/wysiwyg/ack__ack_logo_110_110_1.png";
            cartUrl = "https://www.austinkayak.com/fitguide/yakima/";
            break;
        case "33":
            dealerName = "Rack Boys";
            imgUrl = "https://www.yakima.com/media/wysiwyg/rackboys__logo.png";
            cartUrl = "https://www.rackboys.com/fitguide/yakima/";
            break;
        case "34":
            dealerName = "RackStop";
            imgUrl = "http://yakimaassets.s3.us-west-2.amazonaws.com/images/RackStop.png";
            cartUrl = "https://rackstop.dev1.p80w.com/yakima";
            break;
        case "35":
            dealerName = "Racks Unlimited";
            imgUrl = "http://d2amiavn18tu8z.cloudfront.net/skin/frontend/yakima/default/images/racksunlimited.jpg";
            cartUrl = "https://www.racks-unlimited.com/yakima-fit-template/";
            break;
        case "37":
            dealerName = "AutoRacks";
            imgUrl = "//cdn.shopify.com/s/files/1/1568/3969/t/4/assets/logo.png?2082387061911371153";
            cartUrl = "https://autoracks.com/";
            break;
        case "38":
            dealerName = "ETrailer";
            imgUrl = "https://www.etrailer.com/static/images/styles/etrailer-logo.svg";
            cartUrl = "www.etrailer.com/cart/transfer";
            break;
      case "39":
        dealerName = "Great Outdoor Provision";
        imgUrl = "https://cdn.shopify.com/s/files/1/0266/3943/3776/t/3/assets/gopc-logo-white.png?v=1643058591";
        cartUrl = "https://greatoutdoorprovision.com/cart/";
        break;
        
      case "40":
        dealerName = "RackStarz";
        imgUrl = "http://yakimaassets.s3.us-west-2.amazonaws.com/images/rackstarz.png";
        cartUrl = "https://rackstarz-test.myshopify.com/pages/yakima-fit-guide";
        break;

      case "41":
        dealerName = "River Sports Outfitters";
        imgUrl = "http://yakimaassets.s3.us-west-2.amazonaws.com/images/riversports.png";
        cartUrl = "https://riversportsoutfitters.com/pages/AddToCart";
        break;
        
      case "42":
        dealerName = "RealTruck";
        imgUrl = "http://yakimaassets.s3.us-west-2.amazonaws.com/images/realtrucklogo.png";
        cartUrl = "https://realtruck.com/pages/AddToCart";
        break;
    }
    jQuery('#AccessibleNav img').attr('src', imgUrl).attr('height', '60');

     jQuery('.site-header__logo-image').first().html('<img src="' + imgUrl +'" height=60></img>');
  	localStorage.setItem('dealerName', dealerName);
  	localStorage.setItem('cartUrl', cartUrl);


//    jQuery('.site-header__icons-wrapper #dealer_cart_link').attr('href', cartUrl).text('Checkout On ' + dealerName);

//    jQuery('.cart__submit-control').first().val('Checkout On ' + dealerName);
}

function cartPage() {
    var transfer = localStorage.getItem('cart-transfer');
    var cartItems = transfer.split('|');
  jQuery('#partnerCart table tbody').html('');
  var subtotal = 0;
  	for (i = 0; i < cartItems.length; ++i) {
    	var cols = cartItems[i].split(',');
      if(cols[0].length > 0) {
   		var row ='<tr class="cart__row"><td><div class="cart__product-information"><div><div class="list-view-item__title">' + cols[3] + '<p class="cart__remove"><a href="#" onclick="RemoveFromCart(' + i + ');" class="text-link text-link--accent">Remove</a></p></div></div></td><td class="cart__price text-right"><div>$' + parseFloat(cols[2]).toFixed(2) + '</div></td><td class="cart__quantity-td text-right small--hide">' + cols[1] + '</td><td class="cart__final-price text-right small--hide">$' + parseFloat(cols[2]).toFixed(2) + '</td></tr>';
    	jQuery('#partnerCart table tbody').append(row);
        subtotal += parseFloat(cols[2]);
      }
	}
  jQuery('#partner-subtotal').html('$' + subtotal.toFixed(2));
  
  if(jQuery('body').hasClass('whitelabel'))
  	jQuery('#partnerCart .cart__submit-controls').first().html('<input type="button" class="btn btn--small-wide cart__submit" onclick="partnerCheckout(\'' + localStorage.getItem('cartUrl') + '\');" value="Check out at ' + localStorage.getItem('dealerName') + '">');
}
function RemoveFromCart(idx) {
  
  var transfer = localStorage.getItem('cart-transfer');
  var cartItems = transfer.split('|');
  transfer = transfer.replace('|' + cartItems[idx], '');
  console.log('removing ' + '|' + cartItems[idx]);
  
  localStorage.setItem('cart-transfer', transfer);
  cartPage();
  return false;
}
